module.exports = __webpack_public_path__ + "media/images/pic/anime/pink-crayon-3a548571f42a3bd423f5557cbcf469aa.svg";